"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _elementResizeDetector = _interopRequireDefault(require("element-resize-detector"));
let instance;
function resizeDetector(strategy = 'scroll') {
  if (!instance) {
    instance = (0, _elementResizeDetector.default)({
      strategy
    });
  }
  return instance;
}
var _default = exports.default = resizeDetector;